import { weenatIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { DeviceBroadcastNetwork } from '../../enums/Devices';
const BASE_KEY = 'models.device.broadcast_networks';
export function getDeviceBroadcastNetwork(device) {
    const { broadcastNetwork } = device;
    let key;
    switch (broadcastNetwork) {
        case DeviceBroadcastNetwork.CELLULAR:
            key = 'cellular';
            break;
        case DeviceBroadcastNetwork.LoRa:
            key = 'lora';
            break;
        case DeviceBroadcastNetwork.SIGFOX:
            key = 'sigfox';
            break;
    }
    return !isNil(key) ? weenatIntl.t(`${BASE_KEY}.${key}`, { capitalize: true }) : `-`;
}
